import { PurchasingDocument } from './purchasing-document'
import { PurchasingReceiptLineItem } from './purchasing-receipt-line-item'

export class PurchasingReceipt {
    id!: string
    purchaseOrderId!: string
    receiptNumber!: string
    receivedDate!: Date | undefined
    receivedBy!: string
    receivedByHrRef!: number | undefined
    storagePlace!: string
    status!: string
    notes!: string
    source!: string
    createdOn!: Date | undefined
    archived!: boolean

    lineItems: PurchasingReceiptLineItem[] = []
    poNumber!: string
    vendorName!: string
    job!: string
    equipment!: string
    workOrder!: string
    lineItemCount!: number
    invoiceCount!: number
    documents: PurchasingDocument[] = []
}
